import React from "react";
import { FaExclamationTriangle, FaPhoneAlt, FaTimes } from "react-icons/fa";

function SubscriptionRenewalModal({ isOpen, onClose, renewalDate, phoneNumber = "0537565625" }) {
  if (!isOpen) return null;

  // Format date to D/M/YYYY (e.g., 14/9/2026)
  const formatArabicDate = (dateStr) => {
    if (!dateStr) return "14/9/2026";
    try {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        return `${day}/${month}/${year}`;
      }
      const d = new Date(dateStr);
      if (!isNaN(d.getTime())) {
        return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
      }
    } catch (e) {
      console.error(e);
    }
    return dateStr;
  };

  const formattedDate = formatArabicDate(renewalDate);

  return (
    <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      {/* Modal Container */}
      <div className="bg-white rounded-3xl overflow-hidden shadow-2xl max-w-md w-full border border-purple-100/50 flex flex-col transform transition-all duration-300 animate-fadeIn">
        {/* Header Bar */}
        <div className="bg-gradient-to-r from-[#6B11A1] via-[#5B1188] to-[#6B11A1] text-white py-4 px-6 relative flex items-center justify-center">
          {/* Close button on top left */}
          <button
            onClick={onClose}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 text-white flex items-center justify-center transition-all cursor-pointer"
            aria-label="Close"
          >
            <FaTimes className="text-sm" />
          </button>

          {/* Header Title */}
          <h2 className="text-white font-bold text-lg md:text-xl text-center tracking-wide font-sans">
            تنبيه تجديد الاشتراك
          </h2>
        </div>

        {/* Modal Content Body */}
        <div className="p-6 md:p-8 flex flex-col items-center text-center space-y-5 bg-white">
          {/* Warning Icon Badge */}
          <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center text-red-500 shadow-sm mt-1">
            <FaExclamationTriangle className="text-red-500 text-3xl" />
          </div>

          {/* Headline Text */}
          <div className="space-y-1">
            <h3 className="text-slate-900 text-2xl font-black tracking-tight font-sans">
              الحساب سوف ينتهي قريبا
            </h3>
            <p className="text-red-600 font-bold text-sm md:text-base">
              الرجاء التواصل مع الدعم الفني
            </p>
          </div>

          {/* Phone Number Pill Button */}
          <div className="bg-[#581C87] hover:bg-[#4C1D95] text-white rounded-full py-3 px-8 shadow-md flex items-center justify-center gap-3 w-full max-w-xs cursor-pointer transition-all">
            <FaPhoneAlt className="text-white text-base transform -scale-x-100" />
            <span className="text-xl font-extrabold font-mono tracking-wider dir-ltr text-white">
              {phoneNumber}
            </span>
          </div>

          {/* Renewal Date Light Purple Box */}
          <div className="bg-[#F5EDFF] border border-purple-100 rounded-2xl py-3 px-6 text-purple-900 font-bold text-sm text-center w-full shadow-inner">
            <span>التجديد بتاريخ </span>
            <span className="font-mono text-base font-extrabold dir-ltr inline-block mx-1">
              {formattedDate}
            </span>
          </div>

          {/* Red Action Button */}
          <button
            onClick={onClose}
            className="bg-[#DC2626] hover:bg-red-700 text-white font-extrabold text-base py-3.5 rounded-xl w-full shadow-lg shadow-red-500/20 transition-all cursor-pointer mt-2"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionRenewalModal;
